// replaced by webpack.DefinePlugin
declare const __GIT_VERSION__: string;
declare const __GIT_BRANCH__: string;
declare const __DEPLOY_URL__: string;
declare const __OVERRIDE_HOME_ROUTE__: string;

export const buildEnvironment = {
  gitVersion: typeof __GIT_VERSION__ === 'undefined' ? undefined : __GIT_VERSION__,
  gitBranch: typeof __GIT_BRANCH__ === 'undefined' ? undefined : __GIT_BRANCH__,
  deployUrl: typeof __DEPLOY_URL__ === 'undefined' ? undefined : __DEPLOY_URL__,
  overrideHomeRoute: typeof __OVERRIDE_HOME_ROUTE__ === 'undefined' ? '' : __OVERRIDE_HOME_ROUTE__,
};
